import { LinkIcon } from "@heroicons/react/24/solid";
import React from "react";
import { useClipboard } from "use-clipboard-copy";

import { SidebarItem } from "src/shared/components/Sidebar";
import { useSponsorContext } from "src/shared/contexts";
import { getSponsorAuthUrl } from "src/shared/utils/sponsorAuth";

import { successToast } from "../../Toast";

const CopySponsorInvite: React.FC = () => {
  const { company } = useSponsorContext();

  const clipboard = useClipboard();

  const inviteLink = getSponsorAuthUrl(company?.invite_code ?? "", "signup");

  return (
    <SidebarItem
      to={{}}
      current={false}
      onClick={() => {
        clipboard.copy(inviteLink);
        successToast("Copied invite link to clipboard!");
      }}
    >
      <LinkIcon style={{ height: 20, width: 20 }} />
      <span style={{ fontWeight: "bold" }}>Copy Invite Link</span>
    </SidebarItem>
  );
};

export default CopySponsorInvite;
